
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import Header from './components/Header/index.vue'
import LearnMap from './components/LearnMap/index.vue'
import WelcomeAsk from './components/WelcomeAsk/index.vue'
import StudySystem from './components/StudySystem/index.vue'
import More from './components/More/index.vue'
import { Observer } from 'mobx-vue'
import { getStaticJson } from '@xt/client/utils/get-static-json'
import type { CalligraphyLevel2JsonResp } from '@xt/client/utils/activities/types.d.ts'
import { MixinsActivityCommonUse } from '@xt/client/mixins/activities/index'
import AUtils from '@xt/client/utils/activities/index'

@Observer
@Component({
  components: {
    Header,
    LearnMap,
    WelcomeAsk,
    StudySystem,
    More
  },
  async asyncData(ctx) {
    const dataSource = await getStaticJson<CalligraphyLevel2JsonResp>('/mocks/activity-calligraphy-level2.json')

    // 初始化所需课程购买状态数据
    await AUtils.loadCourseListHasbuy()

    if (!dataSource) {
      ctx.redirect('/')
    }

    return {
      dataSource
    }
  }
})
export default class CalligraphyLevel2 extends Mixins(MixinsActivityCommonUse) {
  dataSource: CalligraphyLevel2JsonResp

  created(): void {
    this.init(this.dataSource)
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
